// 以下js：モーダルを開く、search_formで選択された日付を取得、一括公開フォームでフォームで表示＋パラメータとして設定
$(document).on('click', '#bulk-release-button', function() {
  var selectedYear = $('#search_form_date[name="report_form[date(1i)]"]').val();
  var selectedMonth = $('#search_form_date[name="report_form[date(2i)]"]').val();
  var selectedDate = selectedYear + '年' + selectedMonth + '月分の公開ステータス';
  var selectedDateDb = selectedYear + '-' + (selectedMonth < 10 ? '0' + selectedMonth : selectedMonth) + '-01';
  $('#selected-date-placeholder').text(selectedDate);
  $('#bulk_release_date_field').val(selectedDateDb);
});
